import { MessageBulletedOffIcon } from './MessageBulletedOffIcon';

/**
 * author: Google
 * id 5AAB267C-9A9C-4966-862D-A2AC910494E5
 * name message-bulleted-off
 * version: 1.7.12
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/message-bulleted-off.svg
 * tags
 */
export const SpeakerNotesOffIcon = MessageBulletedOffIcon;
export default SpeakerNotesOffIcon